import "@ionic/core";
import "swiper";

// Global script entry; export default function required by Stencil build
export default () => {};
